<template>
  <div>
    <!-- <HeaderNavbar /> -->
    <el-row>
      <HeaderNavbar :activeIndex="'3'" />
    </el-row>

    <div class="adjust bggrey">
      <div class="adjust-inner">
        <el-row>
          <el-col :span="16">
            <h2>什么是气象调整方法？</h2>
            <p>
              为了客观和公平地评价空气质量情况，我们将使用统计学气象调整方法，剔除气象因素对空气质量数据的影响，以得到背景排放度量。
              基于 2013 年 3 月到 2024 年 2 月累积九年的小时气象数据，对 “3+130”
              城市分别构造基准气象条件，在此基准气象条件下计算各季节污染物的浓度，通过控制气象条件，捕捉潜在排放量的变化。
            </p>
            <!-- 具体来说，我们采用核估计方法，对各年份和季度的污染与气象数据建立调整模型，将该模型作用于八年基准气象的经验分布函数，计算调整均值。 -->
          </el-col>
          <el-col :span="8">
            <el-image
              :src="imgsrc"
              fit="scale-down"
              style="height: 260px; padding-left: 20px"
            >
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="flex-box">
      <div
        v-for="idx in 9"
        :key="idx"
        class="content-card"
        :class="contentClass(idx)"
      >
        <div>
          <router-link
            :to="{ path: '/results-sub/' + contents[idx - 1].query }"
          >
            <h3 class="title">{{ contents[idx - 1].title }}</h3>
            <div class="intro">{{ contents[idx - 1].intro }}</div>
            <el-image :src="contents[idx - 1].img">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </router-link>
        </div>
      </div>
    </div>
    <!-- <el-row justify="start" type="flex">
      <el-col
        :span="12"
        class="grid"
        v-for="(content, index) in contents"
        :key="index"
      >
        <div class="grid-content">
          <router-link :to="{ path: '/results-sub/' + content.query }">
            <h3 class="title">{{ content.title }}</h3>
            <div class="intro">{{ content.intro }}</div>
            <el-image :src="content.img">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </router-link>
        </div>
      </el-col>
    </el-row> -->

    <el-row>
      <HFooter />
    </el-row>
  </div>
</template>
<style scoped>
.flex-box {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: center;
  /* align-items: flex-start; */
  max-width: 1440px;
  margin: 0 auto;
  padding-bottom: 20px;
}
.left {
  flex: 1;
  padding: 20px;
  margin: 10px;
  border-radius: 10px;
  min-width: 400px;
}
.right {
  flex: 1;
  padding: 20px;
  margin: 10px;
  border-radius: 10px;
  min-width: 400px;
}
.center {
  flex: 1;
  margin: 10px;
  padding: 20px;
  border-radius: 10px;
  min-width: 400px;
}
.content-card {
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 10px 5px;
}
.adjust-inner {
  max-width: 1440px;
  margin: 0 auto;
  text-align: left;
  padding: 10px 60px;
}
.adjust-inner p {
  text-indent: 2em;
  line-height: 32px;
}

a {
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}
.content-father {
  display: block;
  position: relative;
}

.grid {
  padding: 20px;
}

.grid-content {
  padding-top: 1px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.grid-content:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}

.intro {
  padding: 5px 5px 25px 5px;
  color: #303133;
}
</style>
<script>
// @ is an alias to /src
import HeaderNavbar from "@/components/HeaderNavbar.vue";
import HFooter from "@/components/HFooter.vue";

export default {
  // name: "Home",
  data() {
    return {
      imgsrc: require("@/assets/weather_adj.png"),
      //   imgsrc_hwindex: require("@/assets/hwindex.png"),
      //   imgsrc_monitor: require("@/assets/monitor.png"),

      contents: [
        {
          title: "污染物浓度变化",
          intro:
            "结合气象调整方法，对六大污染物各个季度的平均浓度进行调整，给出季度平均经气象调整之后的平均浓度。经气象调整后的浓度去掉了风速等因素的影响，各城市同时期的浓度更具有可比性。",
          img: require("@/assets/results_pull_time_series.png"),
          query: "pull",
        },
        {
          title: "污染物浓度地图",
          intro:
            "按照污染物浓度等级对同一季度的各个城市的六大污染物浓度进行等级划分并进行浓度排序，此外通过地图的形式可直观观察各个区域污染物浓度的大小。",
          img: require("@/assets/results_pull_maps.png"),
          query: "pullmap",
        },
        {
          title: "“人努力-天帮忙”指数”",
          intro:
            "展示了不同城市各季度“人努力”和“天帮忙”指数的时间序列图，数值越小，“人努力”或“天帮忙”程度越高，说明人为排放低或气象条件有利。同时展示了各季度在所有城市中“人努力”和“天帮忙”指数的排名，数值越小，“人努力”或“天帮忙”程度越高。",
          img: require("@/assets/results_hw_time_series.png"),
          query: "hwindex",
        },
        {
          title: "“人努力-天帮忙”指数坐标图”",
          intro:
            "分别以“人努力”指数、“天帮忙”指数为横、纵坐标轴，标注不同城市某个季度的“人努力-天帮忙”指数；以0%为分界线将区域化为四个象限，“人努力”指数小于0%、“天帮忙”指数大于0%时称为“人努力天不帮忙”，“人努力”指数大于0%、“天帮忙”指数大于0%时称为“人不努力且天不帮忙”，“人努力”指数小于0%、“天帮忙”指数小于0%时称为“人努力且天帮忙”，“人努力”指数大于0%、“天帮忙”指数小于0%时称为“人不努力天帮忙”。",
          img: require("@/assets/results_hw_axis.png"),
          query: "hwindexAxis",
        },

        {
          title: "“人努力-天帮忙”指数地图”",
          intro:
            "左图以不同城市为横坐标、“人努力”或“天帮忙”指数为纵坐标展示了各季度“人努力”或“天帮忙”指数及排名变化，其中指数为柱状表示，排名为曲线表。右图展示了评估城市的地理位置，蓝色代表“人努力”或“天帮忙”，红色代表“人不努力”或“天不帮忙”。",
          img: require("@/assets/results_hw_map.png"),
          query: "hwindexMap",
        },

        {
          title: "污染物浓度等级",
          intro:
            "对各个城市经气象调整后的年平均浓度进行等级划分，并同时展示六种污染物的污染浓度等级，可直观观察各个城市需要重点关注的污染物。",
          img: require("@/assets/results_pull_ext.png"),
          query: "ext",
        },
        {
          title: "污染物降幅及综合改善情况",
          intro:
            "给出六种污染物自2014以来累积降幅与平均降幅及其排名，累积降幅指首尾两年下降比例，平均降幅则为逐年降幅的平均；进一步地，我们计算了去除气象因素后六种污染物累积降幅的均值，给出综合改善情况及其排名。",
          img: require("@/assets/results_pull_reduce.png"),
          query: "reduce",
        },
        {
          title: "监视坐标图",
          intro:
            "将六种污染物分成三对给出监视坐标图。每个图中右上象限指两种污染物均过高，左上和右下象限表示一种污染物过高，左下象限的城市情况相对较好。六种污染物超标标准分别为60 微克/立方米（PM2.5）、50 微克 /立方米（PM10-2.5）、25 微克/立方米（二氧化硫）、1.25 毫克/立方米（一氧化碳）、120 微克 /立方米（春夏两季 8 小时臭氧）、45 微克/立方米（二氧化氮）。这些标准是参考国家标准、目前的城市均值浓度分布和数据的区分度而定。",
          img: require("@/assets/results_monitor.png"),
          query: "monitor",
        },
        {
          title: "六大污染物雷达图",
          intro:
            "给出六种污染物各个季度的雷达图，便于直观对比各个城市之间的六种污染物浓度大小。",
          img: require("@/assets/results_radar.png"),
          query: "radar",
        },
      ],
    };
  },
  components: {
    HeaderNavbar,
    HFooter,
  },
  created() {},
  methods: {
    contentClass(idx) {
      if (idx == 1 || idx == 4) {
        return "left";
      } else if (idx == 2 || idx == 5) {
        return "center";
      } else {
        return "right";
      }
    },
  },
};
</script>
